import React, { useRef } from "react";
import { Nav } from "react-bootstrap";
import "./BurgerMenu.scss";
import { useTypedDispatch } from "store";
import { logout } from "store/users/thunkActions";

// imports image
import MenuCloseIcon from "assets/images/Menu-close.svg";
import { useNavigate } from "react-router-dom";
import { localStorageKeys } from "config/localStorageKeys";
import { BurgerMenuProps } from ".";
import { useOutsideAlerter } from "features/game/components/Pagination/CustomSelect";

const BurgerMenuDesktop = ({ viewOpenLeftMenu, handleClickCloseLeftMenu }: BurgerMenuProps) => {
  const navigate = useNavigate();
  const wrapperRef = useRef(null);
  const dispatch = useTypedDispatch();
  useOutsideAlerter(wrapperRef, () => {
    handleClickCloseLeftMenu && handleClickCloseLeftMenu();
  });

  if (!viewOpenLeftMenu) return null;
  return (
    <div className="left-menu-main-wrapper burger-menu-desktop" ref={wrapperRef}>
      <div className="menu-btn-wrapper">
        <button className="menu-btn-close" onClick={handleClickCloseLeftMenu}>
          <img src={MenuCloseIcon} alt="" />
        </button>
      </div>
      <Nav className="navbar-main-left-menu">
        <Nav.Link
          onClick={() => {
            navigate("/my_profile");
            handleClickCloseLeftMenu && handleClickCloseLeftMenu();
          }}
          className="nav-item">
          החשבון שלי
        </Nav.Link>
        <Nav.Link
          onClick={() => {
            navigate("/my_profile?tab=Settings");
            handleClickCloseLeftMenu && handleClickCloseLeftMenu();
          }}
          className="nav-item">
          הגדרות
        </Nav.Link>
        <Nav.Link onClick={() => navigate("/help")} className="nav-item">
          עזרה
        </Nav.Link>
        {/* <Nav.Link
          onClick={() => {
            window.open("https://members.gobeb.co.il/Login.aspx", "_blank");
          }}
          className="nav-item">
            לאתר הישן
        </Nav.Link> */}
        {/* <Nav.Link className="nav-item" href="https://api.whatsapp.com/send?phone=972523292290"> */}
        <Nav.Link className="nav-item" onClick={() => navigate("/contact")}>
          צרו קשר
        </Nav.Link>
        <Nav.Link
          onClick={() => {
            dispatch(logout());
            localStorage.setItem(localStorageKeys.userInfo, "");
            navigate("/");
          }}
          className="nav-item">
          התנתקות
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default BurgerMenuDesktop;
